<template>
  <section class="member-profile-box">
    <main class="member-profile">
      <div class="button">
        <button @click="deleteAccount" class="submit-button button_outline delete-button">
          {{ $t('member-information.key086') }}
        </button>
      </div>

      <!-- 頭像 + 基本資料(不可編輯的資料) -->
      <ProfileHeader />

      <!-- 會員可編輯資訊 -->
      <div class="profile-edit" ref="profileEdit">
        <div class="flex-group">
          <div class="input-group">
            <label><span class="essential">*</span>{{ $t('member-information.key003') }}</label>
            <input v-model="editData.name" @input="nameInput" @blur="nameChecking" :placeholder="$t('member-information.key081')" />
            <div class="alert">{{ validationState.name.message }}</div>
          </div>
          <div class="input-group">
            <label>{{ $t('member-information.key004') }}</label>
            <input v-model="editData.nickname" @input="nicknameInput" @blur="nicknameChecking" :placeholder="$t('member-information.key081')" />
            <div class="alert">{{ validationState.nickname.message }}</div>
          </div>
        </div>

        <div class="flex-group">
          <div class="input-group">
            <label>{{ $t('member-information.key009') }}</label>
            <select v-model="editData.gender">
              <option value="" disabled>{{ $t('member-information.key035') }}</option>
              <option :value="1">{{ $t('member-information.key032') }}</option>
              <option :value="2">{{ $t('member-information.key033') }}</option>
              <option :value="3">{{ $t('member-information.key034') }}</option>
            </select>
          </div>
          <div class="input-group">
            <label>{{ $t('member-information.key010') }}</label>
            <vue-tel-input
              v-model="editData.phone"
              :dropdownOptions="dropdownOptions"
              :inputOptions="inputOptions"
              @validate="phoneValidate"
              @blur="phoneChecking"
              mode="international"
            />
            <div class="alert" v-if="validationState.phone.message">{{ validationState.phone.message }}</div>
          </div>
        </div>

        <div class="input-group">
          <label><span class="essential">*</span>{{ $t('member-information.key008') }}</label>
          <input v-model="editData.contactEmail" type="text" @input="emailInput" :placeholder="$t('member-information.key081')" :disabled="verifyShow" />
          <div class="alert">{{ validationState.contactEmail.message }}</div>
          <button type="button" v-if="isEmailChanged && !verifyShow && !verifySuccess" @click="sendVerifyCode" class="submit-button" style="margin-top: 10px">
            {{ $t('member-information.key028') }}
          </button>
          <VerifyCodeInput ref="codeInputRef" v-show="verifyShow" :email="editData.contactEmail" @editEmail="editEmail" @success="handleVerified" />
          <div class="verifySuccess verify_email" v-if="verifySuccess">
            <p>
              <i class="bi bi-check-circle-fill"></i>
              {{ $t('member-information.key027') }}
            </p>
          </div>
        </div>

        <div class="flex-group">
          <div class="input-group">
            <label><span class="essential">*</span>{{ $t('member-information.key011') }}</label>
            <input v-model="editData.birth" type="date" @blur="birthChecking" />
            <div class="alert">{{ validationState.birth.message }}</div>
          </div>
          <div class="input-group"></div>
        </div>
        <div class="input-group" v-if="legalRep">
          <div class="alert">{{ $t('member-information.key093') }}</div>
          <div class="input-group">
            <label><span class="essential">*</span> {{ $t('member-information.key094') }}</label>
            <input
              v-model="editData.legalGuardianName"
              @input="nameInput"
              @blur="legalRepNameChecking"
              :placeholder="$t('member-information.key081')"
              :disabled="legalRepVerifyShow"
            />
            <div class="alert">{{ validationState.legalRepName.message }}</div>
          </div>
          <div class="input-group">
            <label><span class="essential">*</span> {{ $t('member-information.key095') }}</label>
            <input v-model="editData.legalGuardianEmail" type="text" @input="emailInput" :placeholder="$t('member-information.key081')" :disabled="legalRepVerifyShow" />
            <div class="alert">{{ validationState.legalRepEmail.message }}</div>
            <div class="verifySuccess verify_email" v-if="legalRepVerifySuccess">
              <p>
                <i class="bi bi-check-circle-fill"></i>
                {{ $t('member-information.key027') }}
              </p>
            </div>
            <button
              type="button"
              v-if="isLegalEmailChanged && !legalRepVerifyShow && !legalRepVerifySuccess"
              @click="sendLegalRepVerifyCode"
              class="submit-button"
              style="margin-top: 10px"
            >
              {{ $t('member-information.key028') }}
            </button>
            <VerifyCodeInput
              ref="legalRepCodeInputRef"
              v-show="legalRepVerifyShow"
              :email="editData.legalGuardianEmail"
              :email-field="'legalGuardianEmail'"
              @editEmail="editLegalRepEmail"
              @success="handleLegalRepVerified"
            />
          </div>
        </div>

        <div class="flex-group">
          <div class="input-group">
            <label>{{ $t('member-information.key012') }}</label>
            <country-select v-model="editData.area" :country="editData.area" topCountry="TW" :usei18n="false" :placeholder="$t('member-information.key035')" />
          </div>
          <div class="input-group">
            <label>{{ $t('member-information.key013') }}</label>
            <div class="select_arrow" v-if="!isTaiwan">
              <region-select v-model="editData.city" :region="editData.city" :country="editData.area" :usei18n="false" :placeholder="$t('member-information.key035')" />
            </div>

            <div class="select_arrow" v-else>
              <select v-model="editData.city">
                <option value="" disabled hidden>
                  {{ $t('member-information.key035') }}
                </option>
                <option v-for="opt in twCityOptions" :key="opt.value" :value="opt.value">
                  {{ opt.label }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="input-group">
          <label>{{ $t('member-information.key014') }}</label>
          <TwZipcode v-if="isTaiwan" v-model="editData.address" />
          <label class="addressDetail">
            <input v-model="editData.address.addressDetail" :placeholder="$t('member-information.key064')" />
          </label>
        </div>
        <div class="input-group">
          <label>{{ $t('member-information.key015') }}</label>
          <div class="interest-buttons">
            <label v-for="opt in interestOptions" :key="opt.value">
              <input type="checkbox" :value="opt.value" v-model="editData.interests" @change="changeInterests" />
              <span :class="{ selected: isSelected(opt.value) }">
                {{ opt.label }}
              </span>
            </label>
          </div>
          <div class="alert">{{ interestAlert }}</div>
        </div>
        <div class="input-group">
          <label>{{ $t('member-information.key016') }}</label>
          <input type="checkbox" v-model="editData.agreeMail" />
          <input type="checkbox" id="agree_mail" v-model="editData.agreeMail" />
          <label for="agree_mail" class="agree_mail">
            <span style="padding-left: 30px">
              {{ $t('member-information.key017') }}
            </span>
          </label>
        </div>
      </div>
    </main>
    <!-- 操作按鈕 -->
    <button @click="updateUserInfo" :disabled="!hasChanges" class="submit-button save-button">{{ $t('member-information.key053') }}</button>
  </section>
</template>

<script setup>
import { ref, computed, inject, watchEffect, toRaw, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import { VueTelInput } from 'vue-tel-input';
import selectOptionsRaw from '@/components/memberCenter/memberInfo/MemberOptions.json';
import VerifyCodeInput from '@/components/memberCenter/memberInfo/verificationCode.vue';
import TwZipcode from '@/components/memberCenter/memberInfo/TwZipcode.vue';
import ProfileHeader from '@/components/memberCenter/memberInfo/ProfileHeader.vue';
import { validateName, validateNickname, validateBirthDate, validateEmail, validateLegalRepEmailUnique } from '@/utils/validation';
import { deleteUser, updateUserInfo as updateUserInfoApi } from '@/api/apiService';

const { t, locale } = useI18n();
const store = useStore();
const router = useRouter();
const route = useRoute();
const currentLanguage = computed(() => store.state.currentLanguage);
const loading = inject('loading');
const jwt = computed(() => store.state.jwt);
const userData = inject('userData');
const editData = ref(null);
const hasChanges = ref(false);
const currentPath = route.fullPath;
const targetPath = `/${currentLanguage.value}/member/member-info`;

const validationState = ref({
  name: { message: '', valid: false, required: true },
  nickname: { message: '', valid: false, required: true },
  phone: { message: '', valid: false, required: true },
  birth: { message: '', valid: false, required: true },
  contactEmail: { message: '', valid: false, required: true },
  legalRepName: { message: '', valid: false, required: false },
  legalRepEmail: { message: '', valid: false, required: false },
});

/**
 * TO FIX
 * verifyCode 驗證碼區域有兩塊
 * 部分參數是類似的行為想試 開關 或是紀錄成功
 * 可在更改寫法 增加 code 的復用率
 */
const verifyShow = ref(false);
const codeInputRef = ref(null);
const verifySuccess = ref(false);

const legalRep = ref(false);
const legalRepVerifyShow = ref(false);
const legalRepCodeInputRef = ref(null);
const legalRepVerifySuccess = ref(false);

// phone Setting
const phoneIsValid = ref(false);
const dropdownOptions = {
  disabled: false,
  showDialCodeInList: true,
  showDialCodeInSelection: false,
  showFlags: true,
  width: '100%',
};
const inputOptions = {
  placeholder: t('member-information.key065'),
  showDialCode: false,
};

//Country
const isTaiwan = computed(() => editData.value.area === 'TW');

function getSelectOptions(key) {
  const group = selectOptionsRaw[key];
  if (!group) return [];

  return Object.entries(group).map(([value, i18nKey]) => ({
    label: t(i18nKey),
    value,
  }));
}

// TW 縣市下拉選單
const twCityOptions = computed(() => getSelectOptions('twCity'));

const interestOptions = computed(() => getSelectOptions('interests'));
const interestAlert = ref('');

// for Scroll
const profileEdit = ref(null);

// name
const nameInput = () => {
  if (validationState.value.name.valid) {
    editData.value.name = editData.value.name.trim();
    validationState.value.name.valid = '';
  }
};

const nameChecking = () => {
  const result = validateName(editData.value.name, t);
  validationState.value.name.message = result.message;
  validationState.value.name.valid = result.isValid;
};

// nickName
const nicknameInput = () => {
  if (validationState.value.nickname.valid) {
    editData.value.nickname = editData.value.nickname.trim();
    validationState.value.nickname.valid = '';
  }
};

const nicknameChecking = () => {
  const result = validateNickname(editData.value.nickname, t);
  validationState.value.nickname.message = result.message;
  validationState.value.nickname.valid = result.isValid;
};

// birth
const birthChecking = () => {
  legalRepVerifySuccess.value = false;
  const result = validateBirthDate(editData.value.birth, t);
  validationState.value.birth.message = result.message;
  validationState.value.birth.valid = result.isValid;

  if (result.legalRep) {
    legalRep.value = result.legalRep;
  } else {
    editData.value.legalGuardianName = userData.value.legalGuardianName;
    editData.value.legalGuardianEmail = userData.value.legalGuardianEmail;
    legalRep.value = false;
  }
};

const legalRepCheck = () => {
  const result = validateBirthDate(userData.value.birth, t);
  if (result.legalRep) {
    legalRep.value = result.legalRep;
  }
};
//legalRep check
const legalRepNameChecking = () => {
  const result = validateName(editData.value.legalGuardianName, t);
  validationState.value.legalRepName.message = result.message;
  validationState.value.legalRepName.valid = result.isValid;
  return result.isValid;
};
//法定代理人信箱驗證
//  發送 打開驗證碼
const sendLegalRepVerifyCode = async () => {
  const result = validateLegalRepEmailUnique(editData.value.legalGuardianEmail, userData.value.account, userData.value.contactEmail, t);

  validationState.value.legalRepEmail.message = result.message;
  validationState.value.legalRepEmail.valid = result.isValid;

  const nameCheck = legalRepNameChecking();
  if (!nameCheck || !result.isValid) return;

  legalRepVerifyShow.value = true;
  legalRepCodeInputRef.value.sendCode();
};
// 更改信箱 & 關閉驗證碼
const editLegalRepEmail = () => {
  legalRepVerifyShow.value = false;
};
const handleLegalRepVerified = () => {
  legalRepVerifyShow.value = false;
  legalRepVerifySuccess.value = true;
  userData.value.legalGuardianEmail = editData.value.legalGuardianEmail;
};

// vue-tel-input 的原生驗證回傳（on input 時觸發）
const phoneValidate = (object) => {
  phoneIsValid.value = object.valid;
};

// on blur 時觸發我們自己的驗證邏輯
const phoneChecking = () => {
  if (!editData.value.phone || editData.value.phone.trim() === '') {
    validationState.value.phone.message = '';
    validationState.value.phone.valid = true;
    return;
  }
  if (!phoneIsValid.value) {
    validationState.value.phone.message = t('member-information.key072');
    validationState.value.phone.valid = false;
  } else {
    validationState.value.phone.message = '';
    validationState.value.phone.valid = true;
  }
};

const emailInput = () => {
  if (verifySuccess.value) {
    verifySuccess.value = false;
  } else if (legalRepVerifySuccess.value) {
    legalRepVerifySuccess.value = false;
  }
  return;
};
const emailCheck = () => {
  const verifySuccess = userData.value.contactEmail != '';
  if (verifySuccess) {
    validationState.value.contactEmail.valid = true;
  }
};
//  發送 打開驗證碼
const sendVerifyCode = async () => {
  const result = validateEmail(editData.value.contactEmail, t, editData.value.legalGuardianEmail);
  validationState.value.contactEmail.message = result.message;
  validationState.value.contactEmail.valid = result.isValid;

  if (!result.isValid) return;

  verifyShow.value = true;
  codeInputRef.value.sendCode();
};
// 更改信箱 & 關閉驗證碼
const editEmail = (errorMsg) => {
  if (errorMsg) {
    validationState.value.contactEmail.message = errorMsg;
  }
  verifyShow.value = false;
};
const handleVerified = () => {
  verifyShow.value = false;
  verifySuccess.value = true;
};

const isSelected = (key) => editData.value.interests.includes(key);

const changeInterests = () => {
  if (editData.value.interests.length > 3) {
    interestAlert.value = t('member-information.key074');
    editData.value.interests.pop();
  } else {
    interestAlert.value = '';
  }
};

// 驗證是否格式都通過
function checkFormValid() {
  return Object.values(validationState.value).every((field) => {
    return !field.required || field.valid;
  });
}
function checkGuardianInfo() {
  legalRepNameChecking();

  const email = userData.value.legalGuardianEmail;
  const isNameValid = validationState.value.legalRepName.valid;

  const isEmailProvided = !!email && email.trim().length > 0;
  const isEmailCheckPassed = legalRepVerifySuccess.value || isEmailProvided;

  validationState.value.legalRepEmail.valid = isEmailCheckPassed;
  validationState.value.legalRepEmail.message = isEmailCheckPassed ? '' : t('member-information.key089');

  return isNameValid && isEmailCheckPassed;
}

function scrollToProfileEdit() {
  const el = profileEdit.value;
  if (!el) return;

  const top = el.getBoundingClientRect().top + window.scrollY - 50;
  window.scrollTo({
    top,
    behavior: 'smooth',
  });
}

const updateUserInfo = async () => {
  loading.value = true;

  nameChecking();
  nicknameChecking();
  birthChecking();
  phoneChecking();
  emailCheck();

  if (legalRep.value) {
    const isGuardianValid = checkGuardianInfo();
    if (!isGuardianValid) {
      loading.value = false;
      scrollToProfileEdit();
      alert(t('member-information.key092'));
      return;
    }
  }

  const isValid = checkFormValid();
  if (!isValid) {
    scrollToProfileEdit();
    alert(t('member-information.key092'));
    loading.value = false;
    return;
  }

  // 移除點擊更新不必要的更新欄位 contactEmail, legalRep(此欄位由驗證碼驗證時更新)
  function excludeFields(obj, fields) {
    const result = { ...obj };
    fields.forEach((field) => delete result[field]);
    return result;
  }

  try {
    const cleanedData = excludeFields(editData.value, ['contactEmail', 'legalGuardianEmail']);
    cleanedData.phone = phoneIsValid.value ? cleanedData.phone.replace(/\s+/g, '') : '';
    await updateUserInfoApi(cleanedData, jwt.value);
    alert(t('member-information.key090'));
  } catch (error) {
    if ([400, 422].includes(error?.response?.status)) {
      alert(t('member-information.key091'));
    } else {
      console.error('Error updating user info:', error);
    }
  } finally {
    if (currentPath === targetPath) {
      window.location.reload();
      loading.value = false;
    } else {
      router.push(targetPath);
      loading.value = false;
    }
  }
};

watchEffect(() => {
  if (userData.value) {
    editData.value = structuredClone(userData.value);
  }
});

watch(
  () => editData.value,
  (newVal) => {
    const rawEdit = JSON.parse(JSON.stringify(toRaw(newVal)));
    const rawUser = JSON.parse(JSON.stringify(toRaw(userData.value)));
    const isChanged = JSON.stringify(rawEdit) !== JSON.stringify(rawUser);
    hasChanges.value = isChanged;

    checkFormValid();
    if (userData.value && userData.value.birth) {
      legalRepCheck();
    }
  },
  { deep: true, immediate: true },
);

const isEmailChanged = computed(() => {
  return editData.value.contactEmail !== userData.value.contactEmail;
});

const isLegalEmailChanged = computed(() => {
  return editData.value.legalGuardianEmail !== userData.value.legalGuardianEmail;
});

// 刪除帳號
const deleteAccount = async () => {
  const userConfirmed = window.confirm(t('member-information.key083'));
  if (!userConfirmed) return;

  loading.value = true;
  try {
    await deleteUser(jwt.value);
    alert(t('member-information.key084'));
    await router.push(`/${locale.value}`);
    store.dispatch('logout');
  } catch (error) {
    console.error(t('member-information.key085'), error);
  } finally {
    loading.value = false;
  }
};
</script>

<style lang="scss">
section.member-profile-box {
  width: 100%;
  box-sizing: border-box;
  box-shadow: 0 2px 5px rgba(255, 255, 255, 0.2);
  ::-webkit-calendar-picker-indicator {
    filter: invert(1);
  }
  .member-profile {
    padding: 20px;
  }

  .button {
    display: flex;
    justify-content: flex-end;

    .submit-button {
      margin: 0;
      padding: 0.5rem 1rem;
      border: 1px solid #fff;
      margin-right: 1rem;
      &:hover {
        background: transparent;
      }
    }
    .button_outline {
      border: none;
      text-decoration: underline;
      text-underline-offset: 5px;
      background-color: transparent;
      color: #757575;
      font-size: 14px;

      &:hover {
        color: #d0d0d0;
      }
    }
  }
  .save-button {
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 1rem 0;
    margin-top: 20px;
    border-radius: 0;
    &:disabled,
    &:hover:disabled {
      color: #757575;
      background-color: #282828;
    }
  }
  .flex-group {
    display: flex;
    gap: 20px;
  }
  .input-group {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-bottom: 12px;

    input,
    select {
      height: 2.4em;
    }

    label {
      margin-bottom: 5px;
    }
  }

  .input-group input,
  .input-group select {
    border: 1px solid rgb(255, 255, 255, 0.5);
    color: #fff;
    background-color: transparent;
    border-radius: 5px;
    font-size: 18px;
    padding: 5px 8px 4px;
    outline: none;
    max-width: 100%;
    width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;

    option {
      color: #fff;
      background-color: #2c2c2c;
    }

    &:focus {
      box-shadow: inset 0 1px 1px rgb(57, 93, 134, 0.4), 0 0 8px rgb(132, 165, 203, 0.7);
      border-color: #84a5cb;
    }

    &:disabled {
      background-color: #2c2c2c;
      color: hsla(0, 0%, 100%, 0.6);
    }
  }

  .input-group .alert {
    font-size: 14px;
    color: $alert;
    font-weight: 400;
  }

  .input-group span.essential {
    color: #fff599;
  }

  .checkbox-group input {
    margin-right: 10px;
  }

  .profile-actions button:disabled {
    background: #ccc;
    cursor: not-allowed;
  }

  .vue-tel-input {
    width: 100%;
    border: none;
    padding: 0;
    outline: none;
  }

  .vue-tel-input:hover {
    border: none;
    outline: none;
  }

  .vue-tel-input:focus-within {
    box-shadow: none;
  }

  .vti__dropdown:hover,
  .vti__dropdown.open {
    background-color: transparent;
  }

  .vti__dropdown-item.highlighted {
    background-color: #636363;
  }

  .vti__dropdown-list {
    border: 1px solid transparent;
    border-radius: 5px;
  }

  .vti__dropdown-item {
    background-color: #1e1e1e;
    outline: none;
  }

  .verifySuccess {
    i.bi-check-circle-fill {
      color: #6cc95a;
      vertical-align: text-bottom;
    }
  }

  .interest-buttons {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    padding-top: 5px;
  }

  .interest-buttons label {
    margin-right: 10px;
    margin-bottom: 20px;
    cursor: pointer;
  }

  .interest-buttons span {
    padding: 4px 10px 6px;
    border: 1px solid #ffffff;
    border-radius: 5px;
    transition: background-color 0.2s;
  }

  .interest-buttons span.selected {
    background-color: rgb(162, 31, 195, 0.5);
  }

  input[type='checkbox'] {
    display: none;
  }

  .agree_mail {
    position: relative;
  }

  input[type='checkbox'] + label::before {
    vertical-align: middle;
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    display: inline-block;
    width: 20px;
    height: 20px;
    border: 1px solid $primary;
    border-radius: 3px;
    margin-top: 3px;
  }

  input[type='checkbox']:checked + label::before {
    content: '';
    vertical-align: middle;
    background: url('/src/assets/img/public/check.png') no-repeat;
    background-size: contain;
  }

  input[type='checkbox'] + label:hover::before {
    outline: 1px solid $btn_hover;
  }
}

@media (max-width: 441px) {
  section.member-profile-box {
    margin-bottom: 10vh;
    .button .delete-button {
      margin-right: 0;
    }
    .flex-group {
      flex-direction: column;
      gap: 0;
    }
    .verify-code .flex-group {
      flex-direction: row;
    }
  }
}
</style>
